import ReactJson from 'react-json-view'

import { cap } from '../../State'

export const JsonViewer = ({ style, ...props }) => {
  const [darkMode] = cap.darkMode.useState()
  return (
    <ReactJson
      onAdd={false}
      displayObjectSize={false}
      displayDataTypes={false}
      onEdit={false}
      onDelete={false}
      collapsed
      sortKeys
      style={{ ...style, overflow: 'auto', backgroundColor: 'transparent' }}
      theme={darkMode ? 'monokai' : 'rjv-default'}
      {...props}
    />
  )
}
